import styled from "styled-components";
import InputText from "components/atoms/input/Text";
import { TextSm } from "components/atoms/text";
import LicenseFile from "components/layouts/Header/ModalMy/LicenseFile";
import COLORS from "components/atoms/colors";
import { InputChange } from "types/Form";

interface CompanyMe {
  name: string;
  site?: string;
  contactNumber: string;
  email: string;
  managerName: string;
  managerNumber: string;
  license: string;
}

interface Props {
  companyMeState: CompanyMe;
  onChageText: (event: InputChange) => void;
  onChageLicense: (file: string) => void;
}

// 내 정보 수정 - 전문가회원
const FormCompany = ({
  companyMeState,
  onChageText,
  onChageLicense,
}: Props) => {
  const {
    name,
    site,
    contactNumber,
    email,
    managerName,
    managerNumber,
    license,
  } = companyMeState;

  return (
    <>
      <Row gap={24} className="mb-5">
        <Row>
          <Title>
            기업명<Essential>*</Essential>
          </Title>
          <InputText
            shape="square"
            name="name"
            value={name}
            onChange={onChageText}
          />
        </Row>
        <Row>
          <Title>기업 사이트</Title>
          <InputText
            shape="square"
            name="site"
            value={site}
            onChange={onChageText}
          />
        </Row>
      </Row>
      <Row gap={24} className="mb-5">
        <Row>
          <Title>
            기업 연락처<Essential>*</Essential>
          </Title>
          <InputText
            shape="square"
            name="contactNumber"
            value={contactNumber}
            onChange={onChageText}
          />
        </Row>
        <Row>
          <Title>
            이메일<Essential>*</Essential>
          </Title>
          <InputText
            shape="square"
            name="email"
            value={email}
            onChange={onChageText}
          />
        </Row>
      </Row>
      <Row gap={24} className="mb-5">
        <Row>
          <Title>
            이름<Essential>*</Essential>
          </Title>
          <InputText
            shape="square"
            name="managerName"
            value={managerName}
            onChange={onChageText}
          />
        </Row>
        <Row>
          <Title>
            휴대전화번호<Essential>*</Essential>
          </Title>
          <InputText
            shape="square"
            name="managerNumber"
            value={managerNumber}
            onChange={onChageText}
          />
        </Row>
      </Row>
      <Row gap={24} className="mb-5">
        <Row>
          <Title>
            사업자 등록증 or 명함<Essential>*</Essential>
          </Title>
          <LicenseFile
            name="license"
            file={license}
            onDispatch={(image) => onChageLicense(image)}
          />
        </Row>
        <Row />
      </Row>
    </>
  );
};

const Row = styled.div<{ gap?: number }>`
  display: flex;
  gap: ${({ gap }) => gap || 32}px;
  align-items: center;
  flex: 1;
`;

const Title = styled(TextSm)`
  width: 80px;
  flex: none;
  font-weight: 700;
`;

const Essential = styled.span`
  vertical-align: top;
  color: ${COLORS.error.active};
`;

export default FormCompany;
